import React, { FunctionComponent, useEffect } from "react";
import styles from "./TextForm.module.scss";
import TextFormBlockProps from "./TextFormProps.interface";

import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import Paragraph from "components/Paragraph/Paragraph";
import setInViewClasses from "blocks/hooks/setInViewClasses";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import { useSelector } from "react-redux";

const TextForm: FunctionComponent<TextFormBlockProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const { inViewElementRef, inViewClasses } = setInViewClasses(styles);

    const settings = useSelector(state => state.settings.content);

    const { splitClasses, splitStyles } = useSplitBackground(props);
    const headlineCaseClass = props.settings.headlineCase ? styles[`case_${props.settings.headlineCase}`] : undefined;

    return (
        <section className={combineClasses(styles.wrapper, inViewClasses, ...wrapperClasses)} style={{ ...wrapperStyles, ...splitStyles }} ref={inViewElementRef}>
            <div className={combineClasses(styles.container, ...splitClasses)}>

                <div className={styles.content}>
                    {/* Headline */}
                    {props.content.headline ? (
                        <DynamicHeading key={`head_${props.contentUdi}`} className={combineClasses(styles.headline, headlineCaseClass)} text={props.content.headline} headlineSize={props.settings.headlineSize} headlineWeight={props.settings.headlineWeight} />
                    ) : null}

                    {/* Text */}
                    {props.content.bodyText ? (
                        <Paragraph key={`para_${props.contentUdi}`} className={styles.text} innerHTML={props.content.bodyText} />
                    ) : null}
                </div>

                <div className={styles.form}>
                    <div className={styles.content} rekom-inline-form="true" form-id={props.content.identifier} venue-id={settings?.venueId}></div>
                </div>
            </div>
            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia key={props.contentUdi} {...props.settings.backgroundMedia[0]} />
            ) : null}
        </section>
    );
};

export default TextForm;